import React, { useState, useEffect } from 'react';
import { Drawer, Form, InputNumber, Button, Input, message } from 'antd';
import { onlyNumberRule, requiredRule } from 'utils/forms/validationRules';
import { thousandFormatter } from 'utils/forms/formatter';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { REQUEST_LOADING } from 'constants/alerts';
import { PaymentsService } from 'services/PaymentsService';
import { cardPaymentType } from 'utils/handbooks/paymentsHandbook';

function CardPaymentRefundForm({
  isActive,
  onClose,
  initialValues,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialValues) {
      const { amount, company_name, order, type } = initialValues;

      form.setFieldsValue({
        type: cardPaymentType[type],
        order,
        amount,
        company_name,
      });
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    const { refund_sum } = values;
    const payload = {
      card_payment_id: initialValues?.id,
      refund_sum,
    };

    setLoading(true);
    const hide = message.loading(REQUEST_LOADING);

    try {
      const res = await PaymentsService.cardPaymentRefund(payload);

      if (res) {
        message.success('Возврат успешно выполнен');
        hide();
        setLoading(false);
        form.resetFields();
        onClose();
        onSuccess();
      }
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title="Форма возврата"
      width="50%"
      visible={isActive}
      onClose={onClose}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="order" label="№" rules={[requiredRule]}>
          <Input placeholder="№" readOnly />
        </Form.Item>

        <Form.Item name="company_name" label="Клиент" rules={[requiredRule]}>
          <Input placeholder="Наименование компании" readOnly />
        </Form.Item>

        <Form.Item name="type" label="Тип" rules={[requiredRule]}>
          <Input placeholder="Тип платежа" readOnly />
        </Form.Item>

        <Form.Item name="amount" label="Сумма" rules={[requiredRule]}>
          <InputNumber
            addonAfter="KZT"
            controls={false}
            placeholder="Сумма"
            style={{ width: '100%' }}
            formatter={thousandFormatter}
            readOnly
          />
        </Form.Item>

        <Form.Item
          name="refund_sum"
          label="Сумма возврата"
          dependencies={['amount']}
          rules={[
            requiredRule,
            onlyNumberRule,
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('amount') >= value) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error(
                    'Сумма возврата не может быть больше оригинальной суммы'
                  )
                );
              },
            }),
          ]}
        >
          <InputNumber
            addonAfter="KZT"
            controls={false}
            placeholder="Сумма возврата"
            style={{ width: '100%' }}
            formatter={thousandFormatter}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { CardPaymentRefundForm };
